import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerOrgChart: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const { reportingLineOrgChartRequestHandler } = await import("./mocks/reportingLineOrgChartRequestHandler.ts");

        runtime.registerRequestHandlers([reportingLineOrgChartRequestHandler]);
    }
};
